import L from "leaflet";

export enum Z_INDEX_OFFSETS {
    ICON_HOVERED = 100,
}

/**
 * Returns a new LatLngBounds with certain padding
 */
export const getExpandedBounds = (bounds: L.LatLngBounds) => {
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    const latPadding = (ne.lat - sw.lat) * 0.1; // 10% padding
    const lngPadding = (ne.lng - sw.lng) * 0.1;
    return L.latLngBounds(
        L.latLng(sw.lat - latPadding, sw.lng - lngPadding),
        L.latLng(ne.lat + latPadding, ne.lng + lngPadding),
    );
};
